import AutomatedReports from '../pages/AutomatedReports';
import FastTracks from '../pages/FastTracks';
import PeopleGroups from '../pages/PeopleGroups';
import ProductGroups from '../pages/ProductGroups';
import Reports from '../pages/Reports';
import StoreGroups from '../pages/StoreGroups';
import Surveys from '../pages/Surveys';
import TripGroups from '../pages/TripGroups';

/**
 * gets workspace page component
 * @param {Object} options
 * @param {string} options.path
 * @return {ReactNode}
 */
export const getWorkspacePage = ({ path }) => {
  switch (path) {
    case 'automated-reports':
      return <AutomatedReports />;
    case 'narratives':
      return <FastTracks />;
    case 'people-groups':
    case 'people-groups/:folder_id':
      return <PeopleGroups />;
    case 'product-groups':
    case 'product-groups/:group_id':
      return <ProductGroups />;
    case 'reports':
    case 'reports/:folder_id':
      return <Reports />;
    case 'store-groups':
    case 'store-groups/:group_id':
      return <StoreGroups />;
    case 'surveys':
      return <Surveys />;
    case 'trip-groups':
    case 'trip-groups/:folder_id':
      return <TripGroups />;
    default:
      return null;
  }
};
